import { render } from "./ElevadoresPage.vue?vue&type=template&id=10bdaf32&scoped=true"
import script from "./ElevadoresPage.vue?vue&type=script&lang=js"
export * from "./ElevadoresPage.vue?vue&type=script&lang=js"

import "./ElevadoresPage.vue?vue&type=style&index=0&id=10bdaf32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bdaf32"]])

export default __exports__